import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './../../shared/services/authentication.service';
import { AlertService } from './../../shared/services/alert.service';

const ERROR_MESSAGE = 'Uživatelské jméno nebo heslo bylo zadáno špatně. Zkuste to prosím znovu.';
const SUCCESS_MESSAGE = 'Vítejte. Přihlášení proběhlo úspěšně.';

@Component({
  selector: 'swb-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class LoginComponent implements OnInit {
  model: any = {};

  loading = false;

  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService,
    private _alertService: AlertService) { }

  ngOnInit() {
    // reset login status
    // this.authenticationService.logout();
  }

  login() {
    this.loading = true;
    this._authenticationService.login(this.model.username, this.model.password)
      .subscribe(result => {
        if (result === true) {
          // login successful
          this._router.navigate(['/']);
          this._alertService.success(SUCCESS_MESSAGE);
        } else {
          // login failed
          this.loading = false;
          this._alertService.error(ERROR_MESSAGE);
        }
      });
  }

}
